
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Ein Produkt namens «Migravent» reduzierte die Schwere der Migräne in einer
Studie mit 130 Patienten. Es enthält Vitamin B2, Magnesium, Coenzym Q10 und eine
Reihe weiterer Vitamine und Spurenelemente. Coenzym Q10 allein kann ebenfalls
hilfreich sein, so das Resultat einer kleinen Studie. Empfohlen werden dreimal
täglich 100 Milligramm. Einige Studien haben gezeigt, dass bei Menschen mit
Neigung zu erhöhtem Blutdruck eine gesunde Ernährung mit reduziertem Salzkonsum
(zum Beispiel die DASH-Diät) die Kopfschmerzanfälle ebenfalls reduzieren kann.
Dort wurde aber nicht zwischen Migräne und anderen Kopfschmerztypen
unterschieden.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;